import React, { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { apiPost } from '../api/client';
import type { ForgotPasswordRequest } from '../types/api';
import AlertMessage from '../components/AlertMessage';
import LoadingSpinner from '../components/LoadingSpinner';
import ReportProblemLink from '../components/ReportProblemLink';
import './ForgotPasswordPage.css';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const body: ForgotPasswordRequest = { email };
      await apiPost('/api/auth/forgot-password', body);
      setSubmitted(true);
    } catch (err: any) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  if (submitted) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <h1 className="auth-title">Cedar Vault</h1>
          <p className="auth-subtitle">Check your email</p>
          <div className="divider" />
          <AlertMessage
            type="info"
            message="If your email is registered, you will receive a password reset link. Please check your inbox."
          />
          <div className="auth-links">
            <Link to="/login">Return to sign in</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h1 className="auth-title">Cedar Vault</h1>
        <p className="auth-subtitle">Reset your password</p>
        <div className="divider" />

        <AlertMessage type="error" message={error} />

        <p className="forgot-password-info">
          Enter your email address and we'll send you a link to reset your password.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="fpEmail">Email</label>
            <input
              id="fpEmail"
              className="form-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoComplete="email"
              autoFocus
            />
          </div>

          <button className="btn-primary" type="submit" disabled={loading}>
            {loading ? <LoadingSpinner small /> : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/login">Back to sign in</Link>
        </div>
        <p className="auth-site-link"><ReportProblemLink /></p>
      </div>
    </div>
  );
}
